"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTimestamp = exports.convertTimestamps = exports.convertTimestampsPipe = void 0;
var operators_1 = require("rxjs/operators");
/**
 * rxjs pipe to convert timestamps
 */
function convertTimestampsPipe() {
    return function (input$) { return input$.pipe(operators_1.map(function (val) { return convertTimestamps(val); })); };
}
exports.convertTimestampsPipe = convertTimestampsPipe;
/**
 * convert any timestamp properties to js date format
 * @param firebaseObject
 */
function convertTimestamps(firebaseObject) {
    var _a, _b, _c;
    if (!firebaseObject)
        return firebaseObject;
    // if (typeof firebaseObject === 'undefined') return firebaseObject;
    // if an array was passed
    if (Array.isArray(firebaseObject)) {
        return firebaseObject.map(function (item) { return convertTimestamps(item); });
    }
    // if its a map (object)
    if (firebaseObject instanceof Object) {
        // iterate object properties
        for (var _i = 0, _d = Object.entries(firebaseObject); _i < _d.length; _i++) {
            var _e = _d[_i], key = _e[0], value = _e[1];
            // convert simple properties
            if (value && isTimestamp(value)) {
                firebaseObject = __assign(__assign({}, firebaseObject), (_a = {}, _a[key] = convertTimestamp(value), _a));
                continue;
            }
            // recursively convert items inside array
            if (value && Array.isArray(value)) {
                firebaseObject = __assign(__assign({}, firebaseObject), (_b = {}, _b[key] = value.map(function (item) { return isTimestamp(item) ? convertTimestamp(item) : convertTimestamps(item); }), _b));
                continue;
            }
            // recursively convert inner objects (maps)
            if (value && typeof value === 'object') {
                firebaseObject = __assign(__assign({}, firebaseObject), (_c = {}, _c[key] = convertTimestamps(value), _c));
                continue;
            }
        }
    }
    return firebaseObject;
}
exports.convertTimestamps = convertTimestamps;
;
/**
 * convert any value
 * @param value
 */
function convertTimestamp(value) {
    if (value === null || typeof value === 'undefined')
        return value;
    if (isTimestamp(value)) {
        try {
            return value.toDate();
        }
        catch (_a) {
            return value;
        }
    }
    return value;
}
exports.convertTimestamp = convertTimestamp;
/**
 * verify if value is timestamp
 * @param value
 */
function isTimestamp(value) {
    if (value.hasOwnProperty('seconds') &&
        value.hasOwnProperty('nanoseconds') &&
        typeof value.toDate === 'function') {
        return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map